import { createAction, props } from '@ngrx/store';
import { LeadSourceTag } from '@shared/models/lead-source-tag';

export const loadLeadSourceTags = createAction('[Lead Source Tags] Load Lead Source Tags');

export const loadLeadSourceTagsSuccess = createAction(
  '[Lead Source Tags] Load Lead Source Tags Success',
  props<{ leadSourceTags: LeadSourceTag[] }>(),
);

export const loadLeadSourceTagsFailure = createAction(
  '[Lead Source Tags] Load Lead Source Tags Failure',
  props<{ error: any }>(),
);
